import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import * as Sentry from '@sentry/react';

import './index.css';
import App from './App.tsx';

Sentry.init({
	dsn: 'https://b5e75ed178053826754975607bcb10b6@o4506841464438784.ingest.us.sentry.io/4509005797392384',
});

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}>
			<App />
		</GoogleOAuthProvider>
	</StrictMode>,
);
